import { Box, Typography, styled } from "@mui/material";
import { colors } from "../../theme/colors";

export const SectionHeader = styled(Box)(() => ({
  padding: "8px 16px",
  backgroundColor: colors.background.default,
  borderBottom: `1px solid ${colors.border.light}`,
}));

export const SectionHeaderText = styled(Typography)(() => ({
  fontSize: "12px",
  fontWeight: 600,
  color: colors.text.secondary,
  textTransform: "uppercase",
}));

export const ClearButton = styled(Box)(() => ({
  padding: "8px 16px",
  backgroundColor: colors.background.lightBlue,
  borderBottom: `1px solid ${colors.border.light}`,
  cursor: "pointer",
  "&:hover": {
    backgroundColor: colors.background.lightBlue,
    opacity: 0.9,
  },
}));

export const ClearButtonText = styled(Typography)(() => ({
  fontSize: "12px",
  color: colors.primary.main,
  fontWeight: 500,
}));

export const CustomProcedureItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isSelected" && prop !== "canSelect",
})<{ isSelected?: boolean; canSelect?: boolean }>(({ isSelected, canSelect }) => ({
  display: "flex",
  alignItems: "center",
  padding: "6px 12px",
  borderRadius: isSelected ? "4px" : undefined,
  backgroundColor: isSelected ? colors.background.lightBlue : undefined,
  minHeight: "auto",
  cursor: canSelect ? "pointer" : "not-allowed",
  opacity: canSelect ? 1 : 0.5,
  "&:hover": canSelect && !isSelected ? {
    backgroundColor: colors.background.default,
  } : {},
}));

export const CdtCodeItem = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "isSelected" && prop !== "isFromBundle" && prop !== "isSelectable",
})<{ isSelected?: boolean; isFromBundle?: boolean; isSelectable?: boolean }>(
  ({ isSelected, isFromBundle, isSelectable }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    padding: "6px 12px",
    borderRadius: isSelected || isFromBundle ? "4px" : undefined,
    backgroundColor:
      isFromBundle || isSelected ? colors.background.lightBlue : undefined,
    minHeight: "auto",
    cursor: isFromBundle ? "default" : isSelectable ? "pointer" : "default",
    opacity: !isFromBundle && !isSelectable ? 0.5 : 1,
    "&:hover": isSelectable
      ? {
          backgroundColor: colors.background.default,
        }
      : {},
  }),
);

export const CdtCodeText = styled("span")({
  color: colors.text.secondary,
  fontSize: "14px",
  fontFamily: "Nunito",
  flexShrink: 0,
});

export const CdtDescriptionText = styled("span")({
  color: colors.text.primary,
  fontSize: "14px",
  fontFamily: "Nunito",
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export const CdtCodeLabel = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  flex: 1,
  minWidth: 0,
  overflow: "hidden",
});

export const ItemLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isFromBundle",
})<{ isFromBundle?: boolean }>(({ isFromBundle }) => ({
  fontSize: "14px",
  color: isFromBundle ? colors.primary.main : colors.text.primary,
}));

export const EmptyMessage = styled(Typography)(() => ({
  fontSize: "14px",
  color: colors.text.secondary,
}));

export const BundleChip = styled(Box)(() => ({
  height: "24px",
  flexShrink: 0,
  backgroundColor: colors.background.lightBlue,
  border: `1px solid ${colors.primary.main}`,
  borderRadius: "16px",
  padding: "0 8px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
  fontSize: "14px",
  color: colors.text.primary,
}));
